import React from 'react';

import { DecisionMakerIcon, InfoIcon } from '@change/ds-icons';

import { Badge, Card, Separator, Text } from '@change/ds-core-ui/next';

import type { LegislativeBody } from '../../hooks/useDecisionMakers';

import { Member } from './Member';
import { ViewMore } from './ViewMore';

export const LegislativeBodyCard: React.FC<{
	legislativeBody: LegislativeBody;
}> = ({ legislativeBody: { title, location, displayedDMs, displayViewMoreButton } }) => {
	return (
		<Card key="body.name" className="mb-6 p-6">
			<div className="mb-6 flex flex-col items-center gap-4 md:flex-row">
				<Badge
					className="h-20 w-20"
					iconOnly
					label="Text"
					leadingIcon={<DecisionMakerIcon className="mx-auto" />}
					size="large"
					variant="emphasized"
				/>
				<div className="flex flex-col items-center md:items-start">
					<div className="flex flex-col items-center md:flex-row">
						<Text variant="heading" size="small" className="mr-2">
							{title}
						</Text>
						<div className="flex items-center">
							<Text variant="body" className="mr-2 text-sm text-content-primary-disabled md:text-base">
								{location}
							</Text>
							<InfoIcon size="small" className="text-icon-weaker" />
						</div>
					</div>
				</div>
			</div>
			<div className="mx-4 lg:mx-12">
				{displayedDMs.map((dm, index) => (
					<div className="mb-4" key={dm.id}>
						<Member {...dm} />
						{index !== displayedDMs.length - 1 && (
							<div className="py-6">
								<Separator />
							</div>
						)}
					</div>
				))}
				{displayViewMoreButton && <ViewMore />}
			</div>
		</Card>
	);
};
